module.exports = __webpack_public_path__ + "img/apex_tokencreate.307fe94.png";